import './bootstrap';
import {BrowserRouter as Router} from 'react-router-dom';
import Index from './pages/index';
import backgroundLogo from './assets/background-logo.png';
import {AuthProvider} from './context/auth-context';

function App() {
  return (
    <AuthProvider>
      <div
        className={'h-full min-w-[1140px] text-[13px] bg-[#f1f1f2]'}
        style={{
          backgroundImage: `url(${backgroundLogo})`,
          backgroundPosition: 'right calc(100% + 60px)',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Router>
          <Index />
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
